import NewsCard from './NewsCard.vue'

export default NewsCard
